import axios from '../utils/axios';

export default function saveAutoRejectFeedback(adminId, jobId, feedback) {
    return axios.post(`/admin/${adminId}/job/${jobId}/auto-reject-feedback`, { feedback })
        .then(res => res.data)
}
